

























import { defineComponent, useContext, ref, onMounted } from '@nuxtjs/composition-api'

// Components
import SupportInputField from '../search/SupportSearchInputField.vue'
import SupportTypeahead from '../search/SupportTypeahead.vue'
import PageTitle from '@/components/feature/static-content/PageTitle.vue'

// Store
import { useKnowledgeBaseStore } from '~/store/knowledge-base'

// Types
import { Page } from '@/types/cms/page'

export default defineComponent({
  name: 'SupportHeroSection',

  components: {
    SupportInputField,
    SupportTypeahead,
    PageTitle,
  },

  props: {
    page: {
      type: Object as () => Page,
      required: true,
    },
  },

  setup() {
    const ctx = useContext()
    const heroImageURL = ref('')
    const knowledgeBaseStore = useKnowledgeBaseStore()

    onMounted(() => {
      heroImageURL.value = getHeroImageURL()
    })

    const getHeroImageURL = () => {
      return (
        ctx.$img('a77b00d7-a233-49e6-f76f-ee6e383c2f00', null, {
          provider: 'mc',
        }) + '/2X'
      )
    }

    const onClickOutsideSupportTypeahead = () => {
      knowledgeBaseStore.clearResults('typeahead')
    }

    return {
      heroImageURL,
      onClickOutsideSupportTypeahead,
    }
  },
})
